var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 54,
    viewBox: "0 0 68 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.3921 33.3884C65.3921 44.7718 51.3374 54 34 54C16.6625 54 2.60779 44.7718 2.60779 33.3884C2.60779 22.0049 16.6625 12.7767 34 12.7767C51.3374 12.7767 65.3921 22.0049 65.3921 33.3884Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4913 6.87227C13.3679 3.85493 17.2814 2.84511 19.6072 5.03613L36.9619 21.385L5.95029 29.387L12.4913 6.87227Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3927 5.03607C50.7186 2.84506 54.6321 3.85487 55.5087 6.87221L62.0497 29.387L31.038 21.3849L48.3927 5.03607Z",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0065 29.6097C29.0065 32.4556 25.8123 34.7626 21.8719 34.7626C17.9316 34.7626 14.7374 32.4556 14.7374 29.6097C14.7374 26.7638 17.9316 24.4568 21.8719 24.4568C25.8123 24.4568 29.0065 26.7638 29.0065 29.6097Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2646 29.6097C53.2646 32.4556 50.0704 34.7626 46.1301 34.7626C42.1897 34.7626 38.9955 32.4556 38.9955 29.6097C38.9955 26.7638 42.1897 24.4568 46.1301 24.4568C50.0704 24.4568 53.2646 26.7638 53.2646 29.6097Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4441 24.4568H23.2979V34.7626H20.4441V24.4568Z",
    fill: "#212121"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7023 24.4568H47.5561V34.7626H44.7023V24.4568Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dc249f71b6f70f82e1ddb71f44ac45e0.svg";
export { ForwardRef as ReactComponent };